const RouteList = {
  home: '/',
  signIn: '/auth/sign-in',
  signUp: '/auth/sign-up',
  forgotPassword: '/auth/forgot-password',
  send: '/send',
  sendConfirm: '/send-confirm',
  transactions: '/transactions',
  transactionDetail: '/transaction/:id',
  profile: '/profile',
  referral: '/referral',
  check: '/check',
  merchant: '/merchant',
  merchantCreateOrder: '/merchant/create-order',
  wallet: '/wallet',
  deposit: '/wallet/deposit/:id',
  walletHistory: '/wallet/history',
}

export default RouteList
